import { apiClient } from "../api/client";

export const fetchBlobUrl = async (path: string) => {
  const response = await apiClient.get(path, { responseType: "blob" });
  return URL.createObjectURL(response.data);
};
